import { useState } from 'react';

import { nanoid } from 'nanoid';

const useUUID = () => {
    const [uuid] = useState(nanoid(8));
    return { uuid };
};

export default useUUID;
